<h1 *ngIf="!success">Inscription</h1>
<label>Inscription via un courriel</label>
<div *ngIf="success">
  <h1>Confirmation du compte</h1>
  <div class="alert-success p-4"><p class="font-weight-bold">Votre compte a été créé avec succès</p>L'adresse courriel de votre compte doit être validée. Vous recevrez dans les
    prochaines
    minutes un courriel contenenant les instructions à suivre.</div>

</div>
<form *ngIf="!success" [ngClass]="{'pending': pending === true}" [formGroup]="form" (submit)="submit()">
  <div *ngIf="code">
  <div class="alert-success d-flex mb-3 p-4">Code validé avec succès. Vous êtes sur le point de joindre le groupe «
     ».
  </div>
  <p>Inscrivez-vous à l'aide du formulaire ci-dessous.</p>
  </div>
  <small class="alert-danger p-4 mb-2" *ngIf="error">
    {{error.message}}
  </small>

  <div class="p-4 bg-light">

    <spaq-input-email [form]="form"></spaq-input-email>
    <spaq-input-password [form]="form"></spaq-input-password>
    <spaq-input-password name="confirm_password" label="Confirmer mot de passe" [form]="form"></spaq-input-password>


    <button [primary]="true" kendoButton class="w-100 mt-4" type="submit">Inscription</button>
    <a class="d-flex w-100 mt-4 cta" routerLink="/auth/login/email">Retourner au formulaire de connexion</a>


  </div>
</form>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/components/register-email/register-email.component.html